export type GetProjectResponse = {
  projectInformation: ProjectInformation;
  ifReqSTmpUpdLastDTime: string;
  ifReqSTmpUpdPath: string;
  tstUseTypeCd: string;
  tstUseTypeName: string;
  componentRequirementList: ComponentRequirementList[];
  costEstimation: CostEstimation;
  componentProjectList: ComponentProjectList[];
  stakeholderList: StakeholderList[];
  planStatus: Status;
  executionStatus: Status;
  invalidRoleList: Role[];
  pjtLnchTypeCd: string;
  pjtLnchTypeName: string;
  updateDateTime: string;
  mmTxt: string;
  mmTxtUpdateDateTime: string;
};

type ProjectInformation = {
  pjtName: string;
  pjtDesc: string;
  pjtStartPlnDate: string;
  pjtEndPlnDate: string;
  chnTypeGrpTypeCdList: string[];
  chnTypeGrpTypeName: string;
  trnsMsnTypeCd: string;
  trnsMsnTypeName: string;
  reqEstmtAnsDueDate: string;
};

type ComponentRequirementList = {
  cpntReqId: string;
  dipByRgn: string;
  cpntId: string;
  cpntReqDesc: string;
};

type CostEstimation = {
  pjtBdgtAcqstnReqTypeCd: string;
  pjtBdgtAcqstnReqTypeName: string;
  statsOfAgreementOnBudgetaryTypeCd: string;
  statsOfAgreementOnBudgetaryTypeName: string;
};

type ComponentProjectList = {
  pjtId: string;
  pjtName: string;
  pjtSts: string;
  pjtStsDsplyName: string;
};

type StakeholderList = {
  stkhldrId: string;
  primFlg: string;
  roleCd: string;
  roleName: string;
  teamCd: string;
  teamName: string;
  userId: string;
  emplyNum: string;
  userName: string;
  mlAdrs: string;
  stkhldrNote: string;
};

type Status = {
  tcktId: string;
  stsId: string;
  availebleNxtStsIds: string[];
  availableEvntGrps: string[];
};

export type Role = {
  roleCd: string;
  roleName: string;
  teamCd: string;
};
